<div class="nav-item" (click)="toggle()">
  <ng-content select="page-nav-bar-item-icon"></ng-content>
  <ng-content select="page-nav-bar-item-label"></ng-content>
</div>
<div class="dropdown-wrapper" [hidden]="!isOpen">
  <div class="dropdown-content">
    <ng-content select="[dropdownContent]"></ng-content>
  </div>
</div>
